export default __webpack_public_path__ + "static/media/no-photo-available-icon-8.e17fd2f9.jpg";